import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47d753ab"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d753ab')) {
      api.createRecord('47d753ab', component.options)
    } else {
      api.reload('47d753ab', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=47d753ab", function () {
      api.rerender('47d753ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homePage/index.vue"
export default component.exports